import React from 'react'


// CSS
import './NavBar.css'

function NavBar() {
    return (
        <div className="nav">
            <h1>Filmo</h1>
        </div>
    )
}

export default NavBar
